class ct_variant_picker extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
    this.productContainer = this.closest('ct-main-product') || this.parentElement;
    this.setCorrectVariantID();
  }

  setCorrectVariantID() {
    const units = [...this.querySelectorAll('ct-variant-unit')];
    const options = units.map((unit) => unit.querySelector('[selected]')?.dataset.value);
    const variant = this.variants.find((candidate) =>
      candidate.options.length === options.length &&
      candidate.options.every((value, index) => value === options[index])
    );
    const available = Boolean(variant?.available);

    this.productContainer.querySelectorAll('ct-atc-form').forEach((form) => {
      if (variant) form.setAttribute('variant-id', variant.id);
      else form.removeAttribute('variant-id');
      const button = form.querySelector('.ct-atc-button');
      button.toggleAttribute('soldout', !available);
      button.disabled = !available || button.hasAttribute('submitted');
      button.querySelector('span').innerHTML = available
        ? window.ct_atc.atc_text
        : variant ? window.ct_atc.atc_soldout : this.dataset.unavailable;
    });

    this.productContainer.querySelectorAll('input[name="id"]').forEach((input) => {
      input.value = variant?.id || '';
      input.disabled = !available;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    units.forEach((unit, index) => {
      unit.querySelectorAll('.ct-variant-item').forEach((item) => {
        const availableOption = this.variants.some((candidate) => candidate.available &&
          candidate.options.every((value, position) =>
            value === (position === index ? item.dataset.value : options[position])
          )
        );
        item.toggleAttribute('soldout', !availableOption);
        item.setAttribute('aria-pressed', item.hasAttribute('selected'));
      });
    });

    if (!variant) return;
    const prices = this.productContainer.querySelector('.ct-pricestars-prices');
    if (!prices) return;
    const blockID = prices.getAttribute('block-id');
    const money = (amount) => `${window.ct_currency.symbol}${(amount / 100).toLocaleString('de-DE', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    })}`;
    prices.innerHTML = variant.compare_at_price > variant.price
      ? `<span class="ct-price-regular ct-price-regular-${blockID} ct-linethrough">${money(variant.compare_at_price)}</span><span class="ct-price-sale ct-price-sale-${blockID}">${money(variant.price)}</span>`
      : `<span class="ct-price-regular ct-price-sale-${blockID}">${money(variant.price)}</span>`;
  }
}
customElements.define('ct-variant-picker', ct_variant_picker);

class ct_variant_unit extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('.ct-variant-item').forEach((item) => {
      item.addEventListener('click', () => this.choose(item));
      item.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.choose(item);
        }
      });
    });
  }

  choose(element) {
    this.querySelectorAll('.ct-variant-item').forEach((item) => item.removeAttribute('selected'));
    element.setAttribute('selected', '');
    this.closest('ct-variant-picker').setCorrectVariantID();
  }
}
customElements.define('ct-variant-unit', ct_variant_unit);
